import React from 'react';
import './labelValue.scss';
import trans from '../../translations.json';
import Icon from '../../ds/icons/svg/ontario-icon-dropdown-arrow.svg';

const DataValue = (props) => {
  let upArrow = (
    <span>
      <img
        src={Icon}
        style={{ transform: 'rotate(180deg)' }}
        alt={trans.general.increase[props.lang]}
      />{' '}
      {props.difference.toLocaleString()}{' '}
    </span>
  );
  let downArrow = (
    <span>
      <img alt={trans.general.decrease[props.lang]} src={Icon} />
      {Math.abs(props.difference).toLocaleString()}{' '}
    </span>
  );
  return (
    <div
      className={`cviz-label-value ${
        props.smallLabel ? 'cviz-label-value--small' : ''
      }`}
    >
      <div
        className={`cviz-label-value--label ${
          props.smallLabel ? 'cviz-label-value--small--label' : ''
        }`}
      >
        {props.isLink ? (
          <a
            href="https://www.ontario.ca/page/how-ontario-is-responding-covid-19#section-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span
              dangerouslySetInnerHTML={{
                __html: props.label,
              }}
            />
          </a>
        ) : (
          <span
            dangerouslySetInnerHTML={{
              __html: props.label,
            }}
          />
        )}
      </div>

      <div
        className={`cviz-label-value--value ${
          props.smallLabel ? 'cviz-label-value--small--value' : ''
        }`}
      >
        {props.lang === 'fr'
          ? props.value && props.value.toLocaleString()
          : props.value &&
            props.value
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      </div>
      <div
        className={`cviz-label-value--value ${
          props.smallLabel ? 'cviz-label-value--small--value' : ''
        }`}
        style={{
          fontSize: '16px',
        }}
      >
        {props.difference === 0 ? (
          <span
            alt={trans.general.noChange[props.lang]}
            id={'cviz-label-value--nochange'}
          >
            ―
          </span>
        ) : props.difference > 0 ? (
          upArrow
        ) : (
          downArrow
        )}
      </div>
    </div>
  );
};

export default DataValue;
